import type { ReactNode } from 'react';
import { cn } from '@tailoring-crm/ui';

/**
 * The title block every screen opens with. On a phone the action drops below the title and
 * goes full width; on a laptop it sits beside it. Screens do not lay this out themselves, so
 * the product does not end up with nine slightly different page headings.
 */
export interface PageHeaderProps {
  title: string;
  description?: string;
  /** Primary action for the screen. */
  action?: ReactNode;
  className?: string;
}

export function PageHeader({ title, description, action, className }: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-3 pb-4 sm:flex-row sm:items-start sm:gap-4', className)}>
      <div className="min-w-0 flex-1">
        <h2 className="text-xl font-semibold leading-tight">{title}</h2>
        {description ? <p className="mt-1 text-sm text-muted-foreground">{description}</p> : null}
      </div>
      {action ? <div className="flex shrink-0 gap-2">{action}</div> : null}
    </div>
  );
}
